import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class UploadHelper extends Component {
  handleFileSelect(event) {
    const file =
      event.target.files && event.target.files.length && event.target.files[0];
    if (file && this.props.onFileSelect) {
      this.props.onFileSelect(file);
    }
  }

  render() {
    return (
      <input
        type="file"
        id="open-file-input"
        ref={this.props._ref}
        style={{ display: 'none' }}
        accept={this.props.accept}
        onChange={this.handleFileSelect.bind(this)}
        onClick={event => {
          event.target.value = null;
        }}
      />
    );
  }
}

UploadHelper.propTypes = {
  onFileSelect: PropTypes.func,
  accept: PropTypes.string,
  _ref: PropTypes.object
};

export default UploadHelper;
